import React from 'react';
import { Bell } from 'lucide-react';
import { useNotifications } from '../../contexts/NotificationContext';

const NotificationBadge = ({ onClick, className = '' }) => {
  const { unreadCount, connectionStatus } = useNotifications();

  return (
    <button
      onClick={onClick}
      className={`relative p-2 rounded-full hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-pri-norm-1 ${className}`}
      title="Notifications"
    >
      <Bell className="h-6 w-6 text-gray-600" />
      
      {/* Unread count badge */}
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-sec-norm-1 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
      
      {/* Connection status indicator */}
      <div className="absolute bottom-0 right-0">
        {connectionStatus.isConnected ? (
          <div className="w-2 h-2 bg-success-norm-1 rounded-full border border-white"></div>
        ) : (
          <div className="w-2 h-2 bg-error-norm-1 rounded-full border border-white"></div>
        )}
      </div>
    </button>
  );
};

export default NotificationBadge;
